"use client";

import { cn } from "@jesus-central-church/shared";

export interface EventsLoadingProperties {
  count?: number;
  className?: string;
}

export function EventsLoading({
  count = 4,
  className,
}: EventsLoadingProperties) {
  return (
    <div className={cn("space-y-4", className)}>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={`skeleton-${index}`}
          className="flex animate-pulse gap-6 rounded-xl border border-freedom/10 bg-freedom/5 p-6"
        >
          <div className="h-20 w-16 rounded-lg bg-freedom/10" />
          <div className="flex-1 space-y-3">
            <div className="h-3 w-20 rounded bg-freedom/10" />
            <div className="h-6 w-3/4 rounded bg-freedom/10" />
            <div className="h-4 w-1/2 rounded bg-freedom/10" />
          </div>
        </div>
      ))}
    </div>
  );
}
